import * as v from 'valibot';

const EnrollmentStatus = v.fallback(
  v.union([
    v.literal('member'), // user got enrolled
    v.literal('requested'), // user is requested to be enrolled.
    v.literal('alreadymember'), // user is already enrolled.
    v.literal('overlimit'), // enrollment limit is reached.
    v.literal('unknown'),
  ]),
  'unknown',
);

export const EnrollmentRequestSchema = v.object({
  status: EnrollmentStatus,
});

export type TEnrollmentStatus = v.Output<typeof EnrollmentStatus>;
